import { AccessControlProvider } from "@refinedev/core";

export const accessControlProvider: AccessControlProvider = {
  can: async ({ resource, action }) => {
    // Get user roles from localStorage
    const user = localStorage.getItem("user");
    const roles: string[] = user ? JSON.parse(user).roles || [] : [];

    // Admin can do everything
    if (roles.includes("admin") || roles.includes("Administrator")) {
      return { can: true };
    }

    // Define resource-based permissions
    const permissions: Record<string, Record<string, string[]>> = {
      leads: {
        list: ["sales", "manager", "viewer"],
        show: ["sales", "manager", "viewer"],
        create: ["sales", "manager"],
        edit: ["sales", "manager"],
        delete: ["manager"],
      },
      inbasket: {
        list: ["sales", "manager", "viewer"],
      },
      dashboard: {
        list: ["sales", "manager", "viewer"],
      },
    };

    // Check if the resource exists in permissions
    if (!resource) {
      return { can: true }; // Default to allow for undefined resources
    }
    const resourcePermissions = permissions[resource];
    if (!resourcePermissions) {
      return { can: true }; // Default to allow for undefined resources
    }

    // Check if the action exists for this resource
    if (!action) {
      return { can: true }; // Default to allow for undefined actions
    }
    const allowedRoles = resourcePermissions[action];
    if (!allowedRoles) {
      return { can: true }; // Default to allow for undefined actions
    }

    // Check if user has any of the allowed roles
    const hasPermission = roles.some((role) =>
      allowedRoles.includes(role.toLowerCase()),
    );

    return { can: hasPermission };
  },

  options: {
    buttons: {
      enableAccessControl: true,
      hideIfUnauthorized: false,
    },
  },
};
